// src/components/PropertyPage/Utils/PropertyInfoSkeleton.js
import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const PropertyInfoSkeleton = () => {
  return (
    <SkeletonTheme baseColor="#f0f0f0" highlightColor="#e0e0e0">
      <div className="PropertyInfoSkeleton">
        {/* Título y ubicación */}
        <div className="PropertyInfoSkeleton__header">
          <Skeleton height={32} width="60%" />
          <Skeleton height={20} width="40%" />
        </div>
        
        {/* Características */}
        <div className="PropertyInfoSkeleton__features">
          {Array(3).fill().map((_, index) => (
            <div key={index} className="PropertyInfoSkeleton__feature">
              <Skeleton height={16} width="30%" />
            </div>
          ))}
        </div>
        
        {/* Descripción */}
        <div className="PropertyInfoSkeleton__description">
          <Skeleton height={16} />
          <Skeleton height={16} width="80%" />
          <Skeleton height={16} width="90%" />
        </div>
        
        {/* Servicios */}
        <div className="PropertyInfoSkeleton__services">
          <Skeleton height={24} width="20%" />
          <div className="PropertyInfoSkeleton__services-grid">
            {Array(6).fill().map((_, index) => (
              <Skeleton key={index} height={40} width={40} />
            ))}
          </div>
        </div>
      </div>
    </SkeletonTheme>
  );
};

export default PropertyInfoSkeleton;